import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import { useTranslation } from 'react-i18next';
import { IntroCard, type IntroCardStep } from '../../../../components/intro-card';

/** Spiegazione compatta in cima al dialog "Nuova scadenza": a cosa serve e i tre passi. */
export function ConsultantDeadlineCreateIntro() {
  const { t } = useTranslation();
  const steps: IntroCardStep[] = [
    {
      icon: <UploadFileOutlinedIcon />,
      title: t('consultant.deadlines.create.intro.step1Title', {
        defaultValue: 'Chi carica il documento',
      }),
      description: t('consultant.deadlines.create.intro.step1Desc', {
        defaultValue: 'Tu adesso, oppure il cliente dalla sua sezione Documenti.',
      }),
    },
    {
      icon: <DescriptionOutlinedIcon />,
      title: t('consultant.deadlines.create.intro.step2Title', {
        defaultValue: 'Cliente e documento',
      }),
      description: t('consultant.deadlines.create.intro.step2DescV2', {
        defaultValue:
          "Scegli il cliente e allega il documento: puoi anche farlo leggere all'IA, che prova a compilare tipo e date.",
      }),
    },
    {
      icon: <NotificationsActiveOutlinedIcon />,
      title: t('consultant.deadlines.create.intro.step3Title', {
        defaultValue: 'Scadenza e avvisi',
      }),
      description: t('consultant.deadlines.create.intro.step3Desc', {
        defaultValue:
          "Tu e il cliente ricevete gli avvisi in tempo; puoi chiedere la firma dell'azienda.",
      }),
    },
  ];

  return (
    <IntroCard
      collapsedHint={t('consultant.deadlines.create.intro.collapsedHint', {
        defaultValue: 'A cosa serve',
      })}
      headline={t('consultant.deadlines.create.intro.headline', {
        defaultValue:
          'Crea una scadenza per i tuoi clienti: Prospero tiene il documento in archivio e manda gli avvisi prima che scada.',
      })}
      ariaLabel={t('consultant.deadlines.create.intro.ariaLabel', {
        defaultValue: 'Mostra o nascondi a cosa serve questa finestra',
      })}
      steps={steps}
    />
  );
}
